import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # MedicalChoice
 *
 * MedicalChoice을 설명하세요.
 */
export const MedicalChoice = types
  .model('MedicalChoice')
  // --------------------------------------------------------------------------
  .props({
    medQstChoiceSid: types.number,
    medQstSid: types.number,
    medQstChoice: types.string,
    order: types.maybeNull(types.number),
    score: types.maybeNull(types.number),
    langCd: types.maybeNull(types.string),
    dscrpt: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model medicalChoice --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IMedicalChoiceSnapshot>) => {
      const newProps = { ...self, ...props } as IMedicalChoice;
      (Object.keys(newProps) as TMedicalChoiceKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMedicalChoice = Instance<typeof MedicalChoice>;
type TMedicalChoiceSnapshot = SnapshotOut<typeof MedicalChoice>;

export interface IMedicalChoice extends TMedicalChoice {}
export type TMedicalChoiceKeys = keyof TMedicalChoiceSnapshot & string;
export interface IMedicalChoiceSnapshot extends TMedicalChoiceSnapshot {}
export const createMedicalChoice = () => types.optional(MedicalChoice, {} as TMedicalChoice);
